"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = updateLangAttribute;
function updateLangAttribute(currentHtml, newHtml) {
	if (currentHtml.lang !== newHtml.lang) {
		currentHtml.lang = newHtml.lang;
		return currentHtml.lang;
	} else {
		return null;
	}
};